import { Box, Flex } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { TextRegular, TextSemiBold } from 'UiKit/typography';
import { CloseIcon, FileNotesIcon } from 'Asset/icon';

import styles from './styles.module.css';

const UploadedFile = ({ file, setFile }) => {
  const { t } = useTranslation('schedule');
  return (
    <Box className={styles['form-upload__uploaded-container']}>
      <Flex gap={'8px'} alignItems={'center'}>
        <FileNotesIcon width="24px" height="24px" color="var(--color-info70)" />
        <Box>
          <TextSemiBold className={styles['form-upload__uploaded-filename']}>{file?.name}</TextSemiBold>
          <TextRegular className={styles['form-upload__uploaded-filesize']}>{(file?.size / 1024).toFixed(2)}{t('fileSizeUnit')}</TextRegular>
        </Box>
      </Flex>
      <CloseIcon size="16px" color="var(--color-info60)" onClick={() => setFile(null)} className={styles['form-upload__reset-button']} />
    </Box>
  );
};

export default UploadedFile;
